// extracted by mini-css-extract-plugin
export default {"tagName":"PreviewTags_tagName__ZiXkl","tagNameNew":"PreviewTags_tagNameNew__exHKF"};